function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useSelector } from 'react-redux';
import { Form } from 'react-bootstrap';
import ChangeHighlightedImmutableUnderReviewControl from './ChangeHighlightedImmutableUnderReviewControl';

// works if rendered in a component, where the IsUnderReviewContext is provided
export default function ChangeHighlightedImmutableUnderReviewFormCheck(_ref) {
  let {
    className = '',
    disabled = false,
    ...props
  } = _ref;
  const isUnderTechnicalReview = useSelector(state => state.review.isUnderTechnicalReview);
  const isDisabled = disabled || isUnderTechnicalReview;
  return /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, _extends({
    as: Form.Check,
    className: className,
    disabled: isDisabled
  }, props));
}